@if (layers().length > 0) {
  <mat-form-field appearance="outline" color="primary">
    <mat-select [formControl]="layerSelector"
                [hideSingleSelectionIndicator]="true"
                class="layer-selector"
                placeholder="Select layer"
                i18n-placeholder="@@core.feature-info.select-layer">
    @for (layer of layers(); track layer.id; let index = $index) {
      <mat-option [value]="layer.id"
                  class="layer-selector-item"
                  [disabled]="layer.disabled"
                  [class.selected]="layer.selected">
        <tm-feature-info-layer-item [layer]="layer"></tm-feature-info-layer-item>
      </mat-option>
    }
    </mat-select>
  </mat-form-field>
} @else {
  <div class="no-result-message" i18n="@@core.feature-info.no-features-found">No features found</div>
}
